import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

const URL = `/auth/login`

const login = (data: {
  email: string
  password: string
  visitorId: string
  language?: ILanguage['locale']
  captcha?: string
  sessionId?: string | null
}): AxiosPromise =>
  apiFetch(URL, {
    data,
    method: `POST`,
  })

export default login
